export default __webpack_public_path__ + "static/media/location.b6bcdc0f.svg";